var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-btn",
    {
      staticClass: "primepulsing btn-df text-none rounded100",
      class: { pulsing: !_vm.noblink },
    },
    [
      _c("v-icon", { attrs: { left: "", medium: "" } }, [
        _vm._v(" mdi-cart-arrow-down "),
      ]),
      _vm.total > 0 && !_vm.$store.getters.hidePrices
        ? _c("span", [_vm._v(_vm._s(_vm._f("priceTotal")(_vm.total)))])
        : _c("span", [_vm._v("In den Korb")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }